import React from 'react';
import BoldButton from './BoldButton';
import KaModal from './KaModal';
import SpinnerButton from './SpinnerButton';

export enum ModalMode {
  Create,
  Edit,
  View,
}

export const modalMode = (canModify: boolean, isCreating: boolean) =>
  !canModify ? ModalMode.View : isCreating ? ModalMode.Create : ModalMode.Edit;

interface IProps {
  mode: ModalMode;
  entityName: string;
  onHide: () => void;
  isSaving: boolean;
  onSubmit: () => void;
  onSubmitAndAssign?: () => void;
  children: React.ReactNode;
}

const EntityModal = (props: IProps) => {
  const submitLabel = props.mode === ModalMode.Edit ? 'Update' : 'Create';

  const footer = props.mode === ModalMode.View
    ? <BoldButton className="btn-ghost-primary" onClick={props.onHide}>Close</BoldButton>
    : props.onSubmitAndAssign
      ? (
        <div className="btn-group">
          <SpinnerButton
            className="w-25 m-1 rounded btn-ghost-primary"
            spinning={props.isSaving}
            onClick={props.onSubmit}>
            {submitLabel}
          </SpinnerButton>
          <SpinnerButton
            className="w-25 m-1 rounded btn-ghost-primary"
            spinning={props.isSaving}
            onClick={props.onSubmitAndAssign}>
            {`${submitLabel} and Assign`}
          </SpinnerButton>
        </div>)
      : (
        <SpinnerButton
          className="btn-ghost-primary"
          spinning={props.isSaving}
          onClick={props.onSubmit}>
          {submitLabel}
        </SpinnerButton>);

  return <KaModal
    show={true}
    onHide={props.onHide}
    title={`${props.mode === ModalMode.View ? 'View' : submitLabel} a ${props.entityName}`}
    body={(<fieldset disabled={props.mode === ModalMode.View} className="border-0 p-0 m-0">
      {props.children}
    </fieldset>)}
    footer={footer}
  />;
};

export default EntityModal;
